<template>
    <div class="product-template __donate __limited-edu __limited-edu--uob __uob-heartbeat-2024 __uob-heartbeat-2024--foldable-bag">
      <div class="container pd-sm-0">
        <div class="col-md-push-2 col-md-8">
        <div class="text-center mb-10">
          <img src="/static/img/uob/uob-limited-education.png" srcset="/static/img/uob/uob-limited-education.png" alt="TCFE x UOB x Limited Education" class="logo pd-15 ma-auto d-block" />
        </div>
        <h1 class="page-title text-center">UOB x Limited Education 2024<br/>การศึกษาสร้างอนาคตที่สดใสให้เด็กไทย</h1>
        <h2 class="sub-title text-center">กระเป๋าหิ้วพับได้ </h2>
      </div>
      </div>
      <div class="container pd-sm-0">
        <div class="col-md-push-1 col-md-10">

          <div class="product product--inline">
            <div class="product__block--form ">
              <div class="radius block shadow ">
                <product-donate-choice
                :show-donate-type="true"
                :product="product"
                v-model="product.price"
                ref="donateChoice"
                classes="col-1-5" />

                <div class="form__wrapper mt-15 mb-15">

                  <!-- NO Option -->
                  <div class="form__section">
                    <label class="form__radio-lg">
                      ไม่ต้องการรับของที่ระลึก
                      <input class="" type="radio" name="optionsRadios" value="" v-model="attributes.info.rewardProduct"  />
                      <span class="checkmark"></span>
                    </label>
                  </div><!-- end form section -->

                  <!-- Take Reward -->
                  <div class="form__section">
                    <label class="form__radio-lg" :class="{disable: isRewardDisabled}">
                      {{ rewardTitleText }} <br />
                      <input class="" type="radio" name="optionsRadios" :value="tshirtProductName" :disabled="isRewardDisabled" v-model="attributes.info.rewardProduct" />
                      <span class="checkmark"></span>
                    </label>

                    <transition name="slide-down">
                      <div class="slide-down-wrapper" :class="{disable: isRewardDisabled}" v-show="isTakeReward">
                        <div class="form__section block-third slide-down-item">
                          <div class="form__item--lmt-deu">
                            <div class="row">
                              <div class="col-sm-12 col-md-6">

                                <!-- BEGIN: Thumbnail -->
                                <div
                                  class="current-thumbnail-wrapper"
                                  @click="showImage(currentThumbnailImage)"
                                >
                                  <img :src="currentThumbnailImage" alt="Limited Education" class="ma-auto d-block mb-10" />
                                </div>

                                <div class="row mb-10 d-flex justify-content-center">
                                  <div
                                    v-for="(thumbnail, i) in thumbnailImages"
                                    :key="i"
                                    class="col-sm-4 col-md-3"
                                  >
                                    <div
                                      class="thumbnail-wrapper"
                                      :class="{ selected: thumbnail === currentThumbnailImage }"
                                      @click="changeThumbnail(thumbnail)"
                                    >
                                      <img :src="thumbnail" alt="Limited Education" class="ma-auto d-block" />
                                    </div>
                                  </div>
                                </div>
                                <!-- END: Thumbnail -->
                              </div>
                              <div class="col-sm-12 col-md-6">

                                <!-- BEGIN: Select Size Option -->
                                <div>
                                  <div class="d-flex justify-content-between align-items-center mb-10">
                                    <strong>ระบุจำนวน</strong>
                                    <strong class="choice-selected">{{ selectedSizeCount }}/{{ rewardCount }}</strong>
                                  </div>
                                  <div class="wrapper-size-choice">

                                    <div
                                      v-for="sizeOption in sizeOptions"
                                      :key="sizeOption.text"
                                      class="size-choice"
                                      :class="{
                                        active: hasSelectedSize(sizeOption.text),
                                        'only-one': rewardCount === 1
                                      }"
                                      @click="selectSize(sizeOption.text)"
                                    >
                                      <label class="">{{ sizeOption.text }}</label>
                                      <div class="text-remark">{{ sizeOption.description }}</div>
                                      <div class="number-field">
                                        <a href="#" @click.prevent.stop="decreaseSize(sizeOption.text)">-</a>
                                        <span class="number-item">{{ selectedSize[sizeOption.text] }}</span>
                                        <a href="#" @click.prevent.stop="increaseSize(sizeOption.text)">+</a>
                                      </div>
                                    </div>

                                    <div class="alert alert--error" v-if="error.rewardConfigSize">{{ error.rewardConfigSize }}</div>

                                  </div>
                                </div>
                                <!-- END: Select Size Option -->

                              </div>
                            </div>
                          </div>
                        </div> <!-- end form_section -->
                         <div class="row">
                          <div class="col-sm-12 col-md-6">
                              <!-- ตำแหน่ง -->
                              <div class="pt-15">
                                  <div><strong>ระบุตำแหน่ง <span style="color: #E82B27">*</span></strong></div>
                                  <div class="form__select">
                                      <!-- rewardConfigChoice (ตำแหน่ง) -->
                                      <select v-model="attributes.info.rewardConfigChoice">
                                          <option value="">-- โปรดระบุตำแหน่ง --</option>
                                          <option
                                          v-for="LevelOption in LevelOptions"
                                          :key="LevelOption.text"
                                          :value="LevelOption.description"
                                          >
                                          {{ LevelOption.description }}
                                          </option>
                                      </select>
                                  </div>
                                  <div class="alert alert--error" v-if="error.rewardConfigChoice">กรุณาระบุตำแหน่ง</div>
                              </div>
                          </div>
                          <div class="col-sm-12 col-md-6">
                              <!-- หน่วยงาน -->
                              <div class="pt-15">
                                  <div><strong>ระบุหน่วยงานของท่าน <span style="color: #E82B27">*</span></strong></div>
                                  <div class="form__select">
                                      <!-- rewardConfigText (หน่วยงาน) -->
                                      <select v-model="attributes.info.rewardConfigText">
                                          <option value="">-- โปรดระบุหน่วยงาน --</option>
                                          <option
                                          v-for="FunctionOption in FunctionOptions"
                                          :key="FunctionOption.text"
                                          :value="FunctionOption.description"
                                          >
                                          {{ FunctionOption.description }}
                                          </option>
                                      </select>
                                  </div>
                                  <div class="alert alert--error" v-if="error.rewardConfigText">กรุณาระบุหน่วยงานของท่าน</div>
                              </div>
                          </div>
                        </div>

                        <div class="container-fluid pa-0 pt-15 mt-15">
                          <div class="row">
                            <!-- สถานที่รับเสื้อ -->
                            <div class="col-sm-6 col-md-6">
                              <div><strong>ระบุสถานที่รับของที่ระลึก <span style="color: #E82B27">*</span></strong><br />
                                <span class="text-remark">พนักงานสาขาจัดส่งให้ที่สาขา โปรดระบุสาขาที่รับของท่านให้ถูกต้อง</span>
                              </div>
                              <div class="form__select">
                                <!-- rewardConfigSize (สถานที่รับเสื้อ) -->
                                <select v-model="attributes.info.pickupPoint">
                                  <option value="">-- โปรดระบุสถานที่ --</option>
                                  <option
                                    v-for="PlaceOption in PlaceOptions"
                                    :key="PlaceOption.name"
                                    :value="PlaceOption.name"
                                  >
                                    {{ PlaceOption.name }}
                                  </option>
                                </select>
                              </div>
                              <div class="alert alert--error" v-if="error.pickupPoint">กรุณาระบุสาขาที่รับของที่ระลึก</div>


                                <div v-if="isPlaceOptionType('select')">
                                  <div v-if="selectedPlaceOption.params.optionTitle"><strong>{{ selectedPlaceOption.params.optionTitle }} <span style="color: #E82B27">*</span></strong></div>
                                  <div class="form__select">
                                    <select v-model="attributes.info.pickupDetail">
                                      <option selected value="">-- {{ selectedPlaceOption.params.optionLabel }} --</option>
                                      <option
                                        v-for="item in selectedPlaceOption.params.optionType.items"
                                        :key="item.name"
                                        :value="item.name"
                                      >
                                        {{ item.name }}
                                      </option>
                                    </select>
                                  </div>
                                  <div class="alert alert--error" v-if="error.pickupDetail">
                                    <span v-if="selectedPlaceOption.params.required">{{ selectedPlaceOption.params.required }}</span>
                                    <span v-else>กรุณากรอกข้อมูล</span>
                                  </div>
                                </div>
                              </div>
                              <div class="col-sm-6 col-md-6">
                                <div class="">
                                  <div v-if="isPlaceOptionType('text')" class="">
                                  <label v-if="selectedPlaceOption.params.optionLabel" for="info_name2_text" class="form__label">
                                    <strong>
                                      {{ selectedPlaceOption.params.optionLabel }} <span style="color: #E82B27">*</span>
                                    </strong><br />
                                    <span class="text-remark">{{selectedPlaceOption.params.optionNote}}</span>
                                  </label>
                                  <input id="info_name2_text" class="form__text" type="text" v-model="attributes.info.pickupDetail" />
                                  <div class="alert alert--error" v-if="error.pickupDetail">
                                    <span v-if="selectedPlaceOption.params.required">{{ selectedPlaceOption.params.required }}</span>
                                    <span v-else>กรุณากรอกข้อมูล</span>
                                  </div>
                                </div>
                                </div>

                            </div>
                          </div>
                        </div>
                      </div>
                    </transition>
                  </div><!-- end form section -->

                </div><!-- end form wrapper -->

                <!-- <donor-info v-model="attributes.info.name"
                  class="pt-15" /> -->

                <page-selector
                  :product="product"
                  v-model="attributes.page"
                  v-show="false" />

                <product-cart-action
                  :product="product"
                  :attributes="attributes"
                  :initialQuantity="1"
                  :addToCartButton="false"
                  :buyNowButton="false"
                  :style="{margin:0}"
                  ref="cartAction" />

                <div class="text-center">
                  <div class="alert alert--warning">โปรดตรวจสอบข้อมูลให้ถูกต้องก่อนกดปุ่มสั่งของที่ระลึก</div>
                  <button type="button" class="btn btn--purple btn--default" @click.prevent="donate">กดเพื่อบริจาค/ชำระเงิน</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>

  <script>
    import DonorInfo from '@/components/DonorInfo'
    import PageSelector from '@/components/PageSelector'
    import ProductCartAction from '@/components/ProductCartAction'
    import ProductDonateChoice from '@/components/ProductDonateChoice'
    import Parser from '@/parser'

    export default {
      name: 'ProductTemplateUOBxLimitedEducation2024',

      components: {
        DonorInfo,
        PageSelector,
        ProductCartAction,
        ProductDonateChoice
      },

      props: {
        title: { type: String, default: 'บริจาค' },
        product: { type: Object, required: true }
      },

      data () {
        return {
          tshirtProductName: 'UOB x Limited Education Foldable Bag',
          attributes: {
            info: {
              rewardProduct: '',
              rewardConfigChoice: '',
              rewardConfigText: '',
              pickupPoint: '',
              pickupDetail: '',
              rewardConfigSize: '',
              shippingRequired: false
            },
            page: ''
          },
          error: {
            rewardConfigSize: false,
            rewardConfigChoice: false,
            rewardConfigText: false,
            pickupPoint: false,
            pickupDetail: false
          },
          selectedSize: {},
          currentThumbnailImage: ''
        }
      },

      computed: {
        rewardTitleText () {
          if (this.rewardCount > 0) {
            return `ต้องการรับของที่ระลึก ${this.rewardCount} รายการ`
          }
          return 'ต้องการรับของที่ระลึก'
        },

        rewardCount () {
          const divider = 300
          return Math.floor(this.product.price / divider)
        },

        isRewardDisabled () {
          return this.product.price < 300
        },

        isTakeReward () {
          return this.attributes.info.rewardProduct === this.tshirtProductName
        },

        selectedSizeCount () {
          return Object.values(this.selectedSize).reduce((prev, curr) => {
            return prev + curr
          }, 0)
        },

        sizeOptions () {
          // S:รอบอก 36 นิ้ว,M:รอบอก 38 นิ้ว,L:รอบอก 40 นิ้ว,XL:รอบอก 42 นิ้ว,XXL:รอบอก 44 นิ้ว
          return this.product.meta.donation_tshirt_size.split(',').map(row => {
            const [ text, description ] = row.split(':')
            return { text, description }
          })
        },
        // ตำแหน่ง
        LevelOptions () {
          // 1:Managing Director,2:Executive Director
          return this.product.meta.donation_level_option.split(',').map(row => {
            const [ text, description ] = row.split(':')
            return { text, description }
          })
        },
        // หน่วยงาน
        FunctionOptions () {
          // 1:Personal Financial Services, 2:Project Management Office
          return this.product.meta.donation_function_option.split(',').map(row => {
            const [ text, description ] = row.split(':')
            return { text, description }
          })
        },
        // สถานที่
        PlaceOptions () {
          return Parser.uob.parsePlaceOption(this.product.meta.donation_place_option)
        },

        selectedPlaceOption () {
          return this.PlaceOptions.find((opt) => opt.name === this.attributes.info.pickupPoint)
        },

        thumbnailImages () {
          return this.product.images
        }
      },

      created () {
        this.initSelectedSize()
        this.initThumbnail()
      },

      methods: {
        hasPlaceOptionDetail () {
          return this.selectedPlaceOption && this.selectedPlaceOption.params && this.selectedPlaceOption.params.optionType
        },
        isPlaceOptionType (type) {
          return this.hasPlaceOptionDetail() && this.selectedPlaceOption.params.optionType.type === type
        },
        initSelectedSize () {
          const selectedSize = {}
          for (const sizeOption of this.sizeOptions) {
            selectedSize[sizeOption.text] = 0
          }
          this.selectedSize = selectedSize
        },

        initThumbnail () {
          this.currentThumbnailImage = this.thumbnailImages[0]
        },

        validate () {
          this.error.rewardConfigSize = false
          this.error.rewardConfigChoice = false
          this.error.rewardConfigText = false
          this.error.pickupPoint = false
          this.error.pickupDetail = false

          let valid = true
          const {info} = this.attributes

          // Not select reward option.
          if (info.rewardProduct === null) {
            this.error.rewardProduct = true
            valid = false
          } else if (info.rewardProduct === this.tshirtProductName) {
            // Validate size selection.
            if (this.selectedSizeCount === 0) {
              this.error.rewardConfigSize = 'กรุณาระบุจำนวน'
              valid = false
            } else if (this.selectedSizeCount > this.rewardCount) {
              this.error.rewardConfigSize = 'เลือกเกินจำนวนที่กำหนดไว้'
              valid = false
            } else if (!info.rewardConfigChoice) {
              this.error.rewardConfigChoice = true
              valid = false
            } else if (!info.rewardConfigText) {
              this.error.rewardConfigText = true
              valid = false
            } else if (!info.pickupPoint) {
              this.error.pickupPoint = true
              valid = false
            } else if (this.selectedPlaceOption && this.hasPlaceOptionDetail() && !info.pickupDetail) {
              this.error.pickupDetail = true
              valid = false
            }
          }

          return valid
        },

        async donate () {
          if (!this.$refs.donateChoice.validate()) {
            return
          }

          if (!this.validate()) {
            return
          }

          // Update reward info.
          if (this.attributes.info.rewardProduct === this.tshirtProductName) {
            // Copy info to update size before re-assign back.
            const info = JSON.parse(JSON.stringify(this.attributes.info))

            // Update size (selected only).
            Object.keys(this.selectedSize).forEach(size => {
              const count = this.selectedSize[size]
              if (count > 0) {
                info[size] = count
              }
            })

            // Re-assign info back to attributes.
            this.attributes.info = info
          }
          if (this.product.meta.receipt_item_description) {
            this.attributes.info._receiptItemDescription = this.product.meta.receipt_item_description
          }
          if (this.product.meta.receipt_item_code) {
            this.attributes.info._receiptItemCode = this.product.meta.receipt_item_code
          }

          // Clear previous cart info.
          await this.$store.dispatch('clearCart')

          // Add donation product to cart and go to checkout.
          this.$refs.cartAction.buyNow()
        },

        showImage (src) {
          this.$modal.show({
            text: `<img class="img-enlarged" src="${src}" />`,
            okButtonText: 'ปิด'
          })
        },

        changeThumbnail (src) {
          this.currentThumbnailImage = src
        },

        hasSelectedSize (text) {
          return this.selectedSize[text] > 0
        },

        selectSize (text) {
          if (this.rewardCount === 1) {
            // Reset all size except selected.
            this.clearSelectedSize()
          }

          // Set size to 1 if it is 0.
          if (this.selectedSize[text] === 0) {
            this.increaseSize(text)
          }
        },

        increaseSize (text) {
          if (this.selectedSizeCount < this.rewardCount) {
            this.selectedSize[text]++
          }
        },

        decreaseSize (text) {
          this.selectedSize[text]--
          if (this.selectedSize[text] < 0) {
            this.selectedSize[text] = 0
          }
        },

        clearSelectedSize () {
          Object.keys(this.selectedSize).forEach(size => {
            this.selectedSize[size] = 0
          })
        }
      },

      watch: {
        'product.price': function (amount) {
          if (!amount || amount < 300) {
            this.attributes.info.rewardProduct = ''
          } else {
            this.attributes.info.rewardProduct = this.tshirtProductName
          }
          this.clearSelectedSize()
        }
      }
    }
  </script>

  <style lang="scss" scoped>
   h1.page-title {
      color: #fff;
      font-size: 1.5em;
      font-weight: 400;
      margin-bottom: 30px;
      @media (min-width: 768px) {
        font-size: 1.75em;
      }
    }


    h2.page-title {
      color: #fff;
      text-shadow: 2px 2px 2px rgba(0, 0, 0, 0.5);
    }
    .block { background: #fff; }
    .btn--default {
      margin: 20px auto 10px;
    }

    .slide-down-wrapper {
      margin-top: 15px;
    }

    .current-thumbnail-wrapper {
      cursor: zoom-in;
    }

    .thumbnail-wrapper {
      border: 1px solid transparent;
      cursor: pointer;

      &.selected {
        border-color: orange;
      }
    }

    .size-choice {
      cursor: pointer;

      &.only-one {
        .number-field {
          display: none;
        }
      }

      &.active {
        border: 1px solid orange;
      }
    }

    .product-template.__uob-2023 {
      background: white;
    }
  </style>



// WEBPACK FOOTER //
// uob-lmtedu-2024-internal-foldable-bag.vue?6e4f3cf4